import globalConfig from '@utiles/officialStore/globalConfig';
const MAIN_HOST = globalConfig.getMainHost();
const dirUrl = `https://gpassport.pnsofficial.com/web_login/dir_login`;
export const NEED_TO_JUMP_PNS_GAMEID = [191, 221, 225, 227, 284];
export const jumpPnsWithToken = (token, targetUrl) => {
  //只有window.atob('MzdnYW1lcy5jb20=')的站点才会跳转
  if (MAIN_HOST === window.atob('MzdnYW1lcy5jb20=')) {
    let newUrl = '';
    const curUrl = window.location.href;
    if (targetUrl) {
      newUrl = targetUrl.replace(MAIN_HOST, 'pnsofficial.com');
    } else {
      newUrl = curUrl.replace(MAIN_HOST, 'pnsofficial.com');
    }
    if (token) {
      window.location.href = `${dirUrl}?passportToken=${token}&to=forward&forward=${encodeURIComponent(
        newUrl
      )}`;
    } else {
      window.location.href = newUrl;
    }
  }
};
